import { render } from "./DTabs.vue?vue&type=template&id=64557104&scoped=true"
import script from "./DTabs.vue?vue&type=script&lang=js"
export * from "./DTabs.vue?vue&type=script&lang=js"

import "./DTabs.vue?vue&type=style&index=0&id=64557104&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64557104"]])

export default __exports__